module.exports = __webpack_public_path__ + "img/button-Dentist-MCD.fcc3ad60.svg";